export default __webpack_public_path__ + "static/media/jolt-65-6.faed419b.jpg";